import React, { useEffect, useState } from "react";
import { extractToken, AUTH_URL } from "../util/config";
import axios from "axios";
import logo from "../util/5-STAR_logo.jpg";
import { ReactComponent as ProcoreLogo } from "../util/Procore.svg";
import "../styles/login.css";

// MUI
import { Link } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

var token = extractToken(document.location.hash);
if (token) {
  const idToken = `Bearer ${token}`;
  localStorage.setItem("idToken", idToken);
  axios.defaults.headers.common["Authorization"] = idToken;
}

function Login() {
  const [mobile, setMobile] = useState(window.innerWidth > 500 ? false : true);

  useEffect(() => {
    const handleResize = () =>
      window.innerWidth > 500 ? setMobile(false) : setMobile(true);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [mobile]);

  return (
    <div>
      <Paper elevation={mobile ? 0 : 5} className="loginContainer">
        <img src={logo} alt="Logo" className="logo" />
        <Typography
          variant="h5"
          color="secondary"
          gutterBottom
          style={{ textAlign: "center", marginTop: 50, fontWeight: "bold" }}
        >
          Delivery Log
        </Typography>
        <Typography variant="subtitle1" color="secondary" align="center">
          Submit delivery tickets to Procore
        </Typography>
        <Button
          variant="outlined"
          className="loginButton"
          href={AUTH_URL}
          startIcon={<ProcoreLogo className="procoreLogo" />}
        >
          LOGIN WITH PROCORE
        </Button>
        <Button color="primary" className="loginHelpButton">
          <Link
            color="inherit"
            underline="none"
            href="mailto:it@5starbuild.com"
          >
            Trouble logging in?
          </Link>
        </Button>
      </Paper>
    </div>
  );
}

export default Login;
